import React, { useContext, useRef } from 'react'
import { Link } from 'react-router-dom'
import { UserContext } from '../context/UserContext'
import { topFunction } from '../Utils/utils'


export default function Header() {
  const { user, setUser } = useContext(UserContext);
  const refAdminMenu = useRef()

  function toggleMenu(){
    refAdminMenu.current.classList.toggle("show")
  }
  
  async function logoutHandler(){
    const requestOptions = {
      method: 'DELETE',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const response = await fetch("/api/logout", requestOptions)
    const data = await response.json();
    window.location.href = "/";
  }

  // Close popup or admin menu - by clicking anywhere outside of it
  window.onclick = function(event) {
    // Overlay Close
    if (event.target.id == 'overlay') {
      document.body.style.overflow = "auto";
      document.body.style.marginRight = '0';
      const overlay = document.getElementById("overlay")
      const popup = document.getElementById("popup")
      const popupConfirm = document.getElementById("popup-confirm")
      const popupDeleteConfirm = document.getElementById("popup-delete-confirm")
      const popupCancel = document.getElementById("popup-cancel")

      if(overlay) overlay.className = '';
      if(popup) popup.className = '';
      if(popupConfirm) popupConfirm.className = '';
      if(popupDeleteConfirm) popupDeleteConfirm.className = '';
      if(popupCancel) popupCancel.className = '';
    }

    // Admin Menu Hover
    if (event.target.id !== 'admin-li') {
      const adminMenu = document.getElementById("admin-menu")
      if(adminMenu) adminMenu.classList.remove("show")
    }
  }

  // Back to top scroll function
  window.onscroll = function(e) {scrollFunction(e)};
  
  function scrollFunction(e) {
    const refReturnTop = document.getElementById("return-to-top") 
    if (document.body.scrollTop > 150 || document.documentElement.scrollTop > 150) {
      if(refReturnTop){
            refReturnTop.style.display = "block";
        }
    } else {
        if(refReturnTop){
            refReturnTop.style.display = "none";
        }
    }
  }
  
  return (
    <>
    <header>
        <div className="header-content">
            <div className="flex-item">
              <Link to="/" title="Home">
                <img className="header-logo" src="assets/images/main_logo2.jpg" alt="Company Logo" align="absmiddle" />
              </Link>
            </div>

            <div className="flex-item header-title center">
              Portal Item Change
            </div>

            <div className="flex-item">
              <ul>
                  {/* {user && <li><Link to="/" title="Home">Home</Link></li>} */}
                  {user && <li><Link to="/" title="Home">Home</Link></li>}
                  {user && <li><Link to="/requests" title="View Requests">Requests</Link></li>}
                  
                  {/* Admin Menu */}
                  {user && user.role === 'admin' &&
                  <li 
                    onClick={toggleMenu}
                    title="Admin Actions"
                    id="admin-li"
                  >
                    Admin
                    <div
                      ref={refAdminMenu}
                      className="admin-menu"
                      id="admin-menu"
                    >
                      <div className="admin-menu-content">
                        {user && user.role === 'admin' && <Link to="/portals" title="Portal Admin">Portals</Link>}
                        {user && user.role === 'admin' &&<Link to="/users" title="User Admin">Users</Link>}
                        {/* {user && user.role === 'admin' &&<Link to="/divisions" title="Billing Divisions">Billing Divisions</Link>}
                        {user && user.role === 'admin' &&<Link to="/pricing" title="Pricing">Pricing</Link>} */}
                      </div>
                    </div>
                  </li>
                  }  
                  
                  {/* {user && user.role === 'admin' && <li><Link to="/portals" title="Portal Admin">Portals</Link></li>}
                  {user && user.role === 'admin' && <li><Link to="/users" title="User Admin">Users</Link></li>}
                  {user && user.role === 'admin' && <li><Link to="/divisions" title="Billing Divisions">Billing</Link></li>}
                  {user && user.role === 'admin' && <li><Link to="/divisions" title="Pricing Setup">Pricing</Link></li>} */}
                  {user && <li><Link to="/" onClick={logoutHandler} title="Logout">Logout</Link></li>}
              </ul>
            </div>
        </div>
    </header>

    <div id="return-to-top" className="return-top" onClick={topFunction}>
      &#x25B2; Return to top
    </div>
    </>
  )
}
